import React from 'react';
import Grid from '@material-ui/core/Grid';
import pdfIcon from '../../../assets/icons/pdfIcon.png'
interface Attachment {
  type: string;
  url: string;
}

interface PostAttachmentsProps {
  attachments: string; // JSON string
}

const PostAttachments: React.FC<PostAttachmentsProps> = ({ attachments }) => {
  try {
    const parsedAttachments: Attachment[] = JSON.parse(attachments);
    return (
      <Grid container spacing={2}>
        {parsedAttachments.map((item, index, arr) => {
          if (item.type === 'pdf') {

            return (
              <Grid item xs={12} key={index}>
                <a
                  href={`${process.env.REACT_APP_IMAGE_URL}/${item.url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    color: '#007bff',
                    textDecoration: 'underline',
                  }}
                >
                  <img src={pdfIcon} style={{ width: '40px', height: '50px' }} />
                  {item.url}
                </a>
              </Grid>
            );
          } else if (item.type === 'image') {
            return (
              <Grid
                item
                xs={12}
                sm={arr.length === 1 ? 12 : 6}
                md={12}
                key={index}
              >
                <img
                  src={`${process.env.REACT_APP_IMAGE_URL}/${item.url}`}
                  alt="attachment"
                  style={{
                    width: '100%',
                    height: '500px',
                    cursor: 'pointer',
                    borderRadius: 8,
                    objectFit: 'cover',
                  }}
                />
                {item?.['fileName'] && (
                  <div style={{ fontSize: '14px', color: '#555',display:'flex',justifyContent:'center' }}>
                    <p style={{ fontSize: '15px', textAlign: 'center' }}>{item?.['fileName']}</p>
                  </div>
                )}              </Grid>
            );
          }

          return null;
        })}
      </Grid>
    );

  } catch (error) {
    console.error("Failed to parse attachments:", error);
    return null; // or render a fallback UI
  }


};

export default PostAttachments;
